import { Request,BaseApiUrl } from "./api";

// 列表
export const getHrEmployeeListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/HrEmployee/get`, { params: params });
};


//新增
export const addHrEmployee = (params) => {
  return Request.post(`${BaseApiUrl}/api/HrEmployee/Post`, params);
};

//编辑
export const editHrEmployee = (params) => {
  return Request.post(`${BaseApiUrl}/api/HrEmployee/Put`, params);
};

//删除
export const removeHrEmployee = (params) => {
  return Request.post(`${BaseApiUrl}/api/HrEmployee/Put`, params);
};
//批量删除

export const batchDeleteHrEmployee = (params) => {
  return Request.post(`${BaseApiUrl}/api/HrEmployee/BatchDelete`, params);
};

// export const batchDeleteHrEmployee = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/HrEmployee/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };
